module.exports = __webpack_public_path__ + "img/xdcj1.0d40a62f.png";